import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'cards.list.modal.title',
        defaultMessage: 'My cards',
    },
    virtual: {
        id: 'cards.list.modal.virtual',
        defaultMessage: 'Virtual',
    },
    physical: {
        id: 'cards.list.modal.physical',
        defaultMessage: 'Physical',
    },
    addNew: {
        id: 'cards.page.add_new',
        defaultMessage: 'Add new',
    },
})
